import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MetricKey, MetricsFacade, SaveMetricViewPayload, getMetricPayload } from '@app/shared/+state/metrics';
import { Filter } from '@app/shared/interfaces/lib/filter.interface';
import { LoadingState } from '@app/shared/interfaces/lib/loading.interface';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'hospitable-save-view-dialog',
  templateUrl: './save-view-dialog.component.html',
  styleUrls: ['./save-view-dialog.component.scss'],
})
export class SaveViewDialogComponent implements OnInit {
  LoadingState = LoadingState;
  publiclyAvailable = false;
  form: UntypedFormGroup | undefined;
  metricKey: MetricKey;
  loadingState$: Observable<LoadingState | null> = of(LoadingState.NotSent);
  appliedFilters: Filter[];

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<SaveViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private metricsFacade: MetricsFacade
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
    });

    if (this.dialogData) {
      const { metricKey, appliedFilters } = this.dialogData;
      this.metricKey = metricKey;
      this.appliedFilters = appliedFilters;

      switch (this.metricKey) {
        case MetricKey.Reservations: {
          this.loadingState$ = this.metricsFacade.saveReservationViewLoadingState$;
          break;
        }
        case MetricKey.Taxes: {
          this.loadingState$ = this.metricsFacade.saveTaxesViewLoadingState$;
          break;
        }
        case MetricKey.Reviews: {
          this.loadingState$ = this.metricsFacade.saveReviewsViewLoadingState$;
          break;
        }
        case MetricKey.Tasks: {
          this.loadingState$ = this.metricsFacade.saveTasksViewLoadingState$;
          break;
        }
      }
    }
  }

  onSaveView() {
    if (this.form && this.metricKey) {
      const { name } = this.form.value;
      const filters = getMetricPayload(this.appliedFilters);
      const payload: SaveMetricViewPayload = { ...{ name, publicly_available: this.publiclyAvailable }, ...filters };

      const loadingStateSubscription$ = this.loadingState$.subscribe((loadingState) => {
        if (loadingState === LoadingState.Success) {
          loadingStateSubscription$ && loadingStateSubscription$.unsubscribe
            ? loadingStateSubscription$.unsubscribe()
            : null;
          this.dialogRef.close();
        }
      });

      switch (this.metricKey) {
        case MetricKey.Reservations: {
          this.metricsFacade.saveReservationView(payload);
          break;
        }
        case MetricKey.Taxes: {
          this.metricsFacade.saveTaxesView(payload);
          break;
        }
        case MetricKey.Reviews: {
          this.metricsFacade.saveReviewsView(payload);
          break;
        }
        case MetricKey.Tasks: {
          this.metricsFacade.saveTasksView(payload);
          break;
        }
      }
    }
  }
}
